import * as React from "react"
import { InformationCircleIcon } from "@heroicons/react/solid"

const PlainH2 = ({ blok, len }) => <h2>{blok.HeadingH2}</h2>

export default PlainH2
